import { defineTable } from "convex/server";
import { v } from "convex/values";


export const validatorReportShare = v.object({
  reportId: v.id("reports"),
  sharedBy: v.id("users"),
  sharedWith: v.id("users"),
  companyId: v.id("companies"), // Para multi-tenant

  // Permisos
  canEdit: v.boolean(),
  canDelete: v.boolean(),

  // Metadata
  createdAt: v.number(),
  expiresAt: v.optional(v.number()),
});

export const report_shares = defineTable(validatorReportShare)
  .index("by_report_id", ["reportId"])
  .index("by_shared_with", ["sharedWith"])
  .index("by_company_id", ["companyId"])
  .index("by_shared_by", ["sharedBy"]);
